// extracted by mini-css-extract-plugin
module.exports = {"features":"Features__features--3nN86","feature":"Features__feature--3EIaL","icon":"Features__icon--2LcRh"};